import React, { useEffect, useState } from "react";
import axios from "axios";

const SellerProduct = () => {
    const [products, setProducts] = useState([]);
    const agentId = localStorage.getItem("user_id"); // Retrieve agent ID from local storage
    const userType = localStorage.getItem("user_type"); // Retrieve user type from local storage

    useEffect(() => {
        // Fetch data from the API
        axios.get("https://api.biznetusa.com/api/get-products")
            .then(response => {
                if (response.data.status === 200) {
                    // Filter products based on the conditions
                    const filteredProducts = response.data.products.filter(product =>
                        product.agent_id === parseInt(agentId) &&
                        userType === "seller" &&
                        product.is_approved !== "pending" // Filter out unapproved products (use "approved" or "rejected")
                    );
                    setProducts(filteredProducts);
                }
            })
            .catch(error => {
                console.error("Error fetching the products:", error);
            });
    }, [agentId, userType]);

    return (
        <div className="product-table">
            {products.length > 0 ? (
                <table>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Location</th>
                            <th>Price</th>
                            <th>Category</th>
                            <th>Subcategories</th>
                            <th>Images</th>
                            <th>Overview</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map(product => (
                            <tr key={product.id}>
                                <td>{product.title}</td>
                                <td>{product.desc}</td>
                                <td>{product.location}</td>
                                <td>${product.price}</td>
                                <td>{product.categories.cat_title}</td>
                                <td>
                                    <ul>
                                        {product.categories.sub_categories.map(subCat => (
                                            <li key={subCat.id}>{subCat.sub_title}</li>
                                        ))}
                                    </ul>
                                </td>
                                <td>
                                    {product.images.map(image => (
                                        <img
                                            key={image.id}
                                            src={`https://api.biznetusa.com/uploads/products/${image.image}`}
                                            alt={`Product ${product.id}`}
                                            className="product-image"
                                            style={{ width: '50px', height: '50px', margin: '5px' }}
                                        />
                                    ))}
                                </td>
                                <td>
                                    {product.overview_sales.length > 0 ? (
                                        <div>
                                            <h3>{product.overview_sales[0].title}</h3>
                                            <p>{product.overview_sales[0].desc}</p>
                                            <p><strong>Price:</strong> {product.overview_sales[0].price}</p>
                                            <p><strong>Beds:</strong> {product.overview_sales[0].beds}</p>
                                            <p><strong>Baths:</strong> {product.overview_sales[0].bath}</p>
                                            <p><strong>Sq. Ft.:</strong> {product.overview_sales[0].sq_ft}</p>
                                        </div>
                                    ) : (
                                        <p>No overview available</p>
                                    )}
                                </td>
                                <td>
                                    {product.is_approved === "approved" ? "Approved" : product.is_approved === "rejected" ? "Rejected" : "Pending"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>Loading products...</p>
            )}
        </div>
    );
};

export default SellerProduct;
